var twoColHeadingWordAnim = (function() {
  return {
    init: init
  };

  //init function
  function init() {
    //All hero unit
    var allWords = document.querySelectorAll(".hero-unit__header-anim");

    //check of count greater than 1
    if (allWords.length > 1) {
      var index = 0,
      eTime = setInterval(function() {
        var current = allWords[index],
        prevIndex = (index - 1) >= 0 ? (index - 1) : allWords.length - 1,
        prev = allWords[prevIndex],
        nextIndex = (index + 1) % allWords.length,
        next = allWords[nextIndex];

        current.classList.remove("active");
        current.classList.add("exit");

        next.classList.add("active");
        next.classList.remove("exit");
        prev.classList.remove("exit");

        index = nextIndex;
      }, 2500);
    }
  }
})();

twoColHeadingWordAnim.init();